/** Native review links remain usable without this progressive scroll enhancement. */
if (!window.avRatingNavigationInitialized) {
  window.avRatingNavigationInitialized = true;

  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const deduplicateAnchors = () => {
      document.querySelectorAll('[data-av-testimonials-anchor]').forEach((anchor, index) => {
        if (index === 0) anchor.id = 'av-testimonials';
        else anchor.removeAttribute('id');
      });
    };
    const findTarget = (hash) => {
      if (!hash || hash === '#') return null;
      try { return document.getElementById(decodeURIComponent(hash.slice(1))); }
      catch { return null; }
    };
    const scrollContainer = (target) => {
      let parent = target.parentElement;
      while (parent && parent !== document.body && parent !== document.documentElement) {
        if (/(auto|scroll|overlay)/.test(getComputedStyle(parent).overflowY) && parent.scrollHeight > parent.clientHeight + 1) return parent;
        parent = parent.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    };
    const headerOffset = () => {
      const header = document.getElementById('header-component');
      if (!header) return 0;
      let offset = header.hasAttribute('sticky') ? header.getBoundingClientRect().height : 0;
      let element = header;
      while (element && element !== document.body && element !== document.documentElement) {
        const styles = getComputedStyle(element);
        if (styles.position === 'fixed' || styles.position === 'sticky') {
          offset = Math.max(offset, element.getBoundingClientRect().height + (parseFloat(styles.top) || 0));
        }
        element = element.parentElement;
      }
      return offset;
    };
    const alignTarget = (target, { smooth = false, focus = false } = {}) => {
      const container = scrollContainer(target);
      const isDocument = container === document.scrollingElement || container === document.documentElement;
      const containerTop = isDocument ? 0 : container.getBoundingClientRect().top + container.clientTop;
      const offset = headerOffset();
      document.body.style.setProperty('--av-rating-scroll-offset', `${offset}px`);
      const top = container.scrollTop + target.getBoundingClientRect().top - containerTop - offset - 16;
      container.scrollTo({ top: Math.max(0, top), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant' });
      if (focus && target instanceof HTMLElement) {
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
      }
    };

    // Capture only these links before a product card's own navigation/view-transition handlers.
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a[data-av-rating-link]');
      if (!link) return;
      if (link.closest('product-card, product-card-link')) event.stopPropagation();
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey ||
        link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      let url;
      try { url = new URL(link.href, window.location.href); }
      catch { return; }
      const current = window.location;
      if (url.origin !== current.origin || url.pathname !== current.pathname || url.search !== current.search) return;
      if (!url.hash && !link.getAttribute('href')?.includes('#')) return;
      event.preventDefault();
      deduplicateAnchors();
      const target = findTarget(url.hash);
      if (!target) return;
      if (current.hash !== url.hash) {
        try { history.pushState({}, '', url.href); }
        catch { /* Scrolling still works when history changes are restricted by an embedded preview. */ }
      }
      alignTarget(target, { smooth: true, focus: true });
    }, true);

    const refreshAnchors = () => requestAnimationFrame(deduplicateAnchors);
    document.addEventListener('shopify:section:load', refreshAnchors);
    document.addEventListener('shopify:section:unload', refreshAnchors);
    document.addEventListener('shopify:section:reorder', refreshAnchors);
    deduplicateAnchors();

    // Product-card links may arrive before fonts and page content have reached their final dimensions.
    const initialHash = window.location.hash;
    if (initialHash && initialHash !== '#' && performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') {
      const initialListeners = new AbortController();
      let interrupted = false;
      const interrupt = () => { interrupted = true; };
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) => {
        document.addEventListener(type, interrupt, { passive: true, signal: initialListeners.signal });
      });
      const initialAlignment = async () => {
        if (document.fonts?.ready) await document.fonts.ready;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          initialListeners.abort();
          deduplicateAnchors();
          const target = findTarget(window.location.hash);
          if (!interrupted && window.location.hash === initialHash && target) alignTarget(target);
        }));
      };
      if (document.readyState === 'complete') initialAlignment();
      else window.addEventListener('load', initialAlignment, { once: true });
    }
  })();
}
